import React, { useState, useContext } from "react";
import '../componentsCSS/Menu.css' // Importer le CSS spécifique à ce composant
import LoginPopup from "../auth/LoginPopup.js";
import { FaUserCheck } from "react-icons/fa";
import { UserContext } from "../UserContext.js"; // Import du contexte utilisateur
import { useNavigate } from "react-router-dom";
import RankingPopup from "./Ranking.js";

const Menu = () => {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isRankingOpen, setIsRankingOpen] = useState(false);
  const { userData, logoutUser } = useContext(UserContext); // Utilise le contexte global
  const navigate = useNavigate();

  // Fonction pour gérer la déconnexion
  const handleLogout = async () => {
    try {
      await logoutUser(); // Utilise la fonction de déconnexion du contexte
      console.log("Déconnexion réussie");

      // Optionnel : Rediriger l'utilisateur vers la page d'accueil
      navigate("/");
    } catch (error) {
      console.error("Erreur lors de la déconnexion :", error);
    }
  };


  return (
    <>
    <nav className="navbar">
    <div className="menu-left">
    {userData ? (
          // Si l'utilisateur est connecté, afficher le nom de l'utilisateur et les rôles
          <button
            className="menu-button"
            onClick={() => setIsLoginOpen(true)}
          >
            {userData.pseudo || "Utilisateur"} 
          </button>
        ) : (
          // Si l'utilisateur n'est pas connecté, afficher "Se connecter"
          <button
            className="menu-button"
            onClick={() => setIsLoginOpen(true)}
          >
            Se connecter
          </button>
        )}
        </div>
        <div className="menu-right">
          <button
            className="menu-button"
            onClick={() => setIsRankingOpen(true)}
          >
            Classement
          </button>
        </div>
    </nav>

      {isLoginOpen && (
        userData ? (
          // Si l'utilisateur est connecté, afficher le pop-up de profil
          <div className="profile-popup-overlay" onClick={() => setIsLoginOpen(false)}>
            <div className="wrapper-user" >
              <div className="profile-popup" onClick={(e) => e.stopPropagation()}>
                <h2>Bienvenue {userData.pseudo || "Utilisateur"}</h2>
                <h1><FaUserCheck className="icon" /></h1>
                <h4>Points : {userData.points ? userData.points : "Aucun points"}</h4>
                <p>Merci de participer au Secret Forsides !</p>
                <p>Découvrez chaque jour une nouvelle case à ouvrir, certaines vous réservent des surprises !</p>
                
                <button 
                className="user-button"
                onClick={() => setIsLoginOpen(false)}
                >Jouer</button>
                <button 
                className="user-button"
                onClick={handleLogout}
                >Se déconnecter</button>
              </div>
            </div>
          </div>
        ) : (
          // Sinon, afficher le pop-up de connexion
          <LoginPopup 
            onClose={() => setIsLoginOpen(false)} 
          />
        )
      )}

      {isRankingOpen && (
        <RankingPopup onClose={() => setIsRankingOpen(false)} />
      )}
    </>
  );
};

export default Menu;
